import { render, staticRenderFns } from "./SlidePanel.vue?vue&type=template&id=c2abf3c8&scoped=true&"
import script from "./SlidePanel.vue?vue&type=script&lang=js&"
export * from "./SlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SlidePanel.vue?vue&type=style&index=0&id=c2abf3c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2abf3c8",
  null
  
)

export default component.exports